"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var NavBarItem_1 = __importDefault(require("./NavBarItem"));
var ui_1 = require("@aperza/ui");
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var PromoteCompanyLink = /** @class */ (function (_super) {
    __extends(PromoteCompanyLink, _super);
    function PromoteCompanyLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PromoteCompanyLink.prototype.render = function () {
        var promoteUrl = "https://www.aperza.com/corp/service/aperzacatalog_guide/";
        var largeDesktopOnly = true;
        var messageId = 'navbar.promote.company';
        if (appConfig.isAperzaMarketplace || !this.props.disableMarketplaceBanner) {
            promoteUrl = "https://www.aperza.com/corp/service/aperza_sellers/";
            largeDesktopOnly = false;
            messageId = 'navbar.promote.company_ec';
        }
        return (react_1.default.createElement(ui_1.WebMediaQuery, { largeDesktopOnly: largeDesktopOnly },
            react_1.default.createElement(NavBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: messageId }), icon: "aperza", openOnNewTab: true, url: promoteUrl })));
    };
    PromoteCompanyLink.propTypes = {
        viewer: prop_types_1.default.shape({
            disableMarketplaceBanner: prop_types_1.default.bool,
        }),
    };
    return PromoteCompanyLink;
}(react_1.default.Component));
exports.default = PromoteCompanyLink;
